import { Chip, ChipProps, useRadioGroup } from "@mui/material";

export function RadioChip(props: ChipProps & { value: string | number }) {
  const radioGroup = useRadioGroup();

  if (radioGroup?.value === props.value) {
    // active chip
    return <Chip color="primary" clickable {...props} />;
  }
  // else
  return <Chip clickable {...props} />;
}
